import React from 'react';
import styled from 'styled-components';
import { useModal } from './ModalContext';

function Backdrop({ children }: { children: React.ReactNode }) {
  const modal = useModal();

  return <StyledContainer onClick={modal.close}>{children}</StyledContainer>;
}

const StyledContainer = styled.div`
  z-index: 100;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  overflow: scroll;
  padding: 60px 24px;
`;

export default Backdrop;
